// eslint-disable-next-line no-undef
module.exports = {
  headers: {
    accept: 'application/json'
  },
  //baseUrl: 'http://localhost:59901/api/'
  //baseUrl: 'https://quiero.forcontrol.com.br/api/'
  baseUrl: 'https://app.quierocafe.com.br/api/'
}
